import React, { useContext, useState } from 'react';
import { createContext } from 'react';
export const appLayoutDefaultState = {
    navCollapsed: false,
};
/**
 * AppLayoutContext
 * - Combines layout state (currently just whether the nav is collapsed) with it's setters
 * and a toggle function. this allows both to be directly accessed from the useAppLayoutContext hook
 */
export const AppLayoutContext = createContext({
    ...appLayoutDefaultState,
    toggleNav: () => undefined,
});
/**
 * useAppLayoutContext
 * @returns layout state combined with util functions to modify it
 */
export const useAppLayoutContext = () => useContext(AppLayoutContext);
/**
 * AppLayoutProvider
 * - Tracks whether the nav is collapsed or not, used for both the outer sidenav
 * on desktop and the header panel on mobile, as well as provides the set & toggle utils
 */
export const AppLayoutProvider = ({ children, initialState }) => {
    const [state, setState] = useState({ ...appLayoutDefaultState, ...initialState });
    const toggleNav = () => {
        setState((prevState) => ({ ...prevState, navCollapsed: !state.navCollapsed }));
    };
    // Merge Individual state variables with modifier functions
    const value = { ...state, toggleNav };
    return React.createElement(AppLayoutContext.Provider, { value: value }, children);
};
